import { Component, ViewChild } from '@angular/core';
import { ViewController, ItemSliding, Item, AlertController, Searchbar,} from 'ionic-angular';

import { Nav, NavParams, MenuController, Events, ModalController  } from 'ionic-angular';

import { RepositoryMyRadiant, HelperMyRadiant, ApiMyRadiant,UserMyRadiant as User} from '@providers/index';
import { CalendarResult } from 'ion2-calendar';
import { AddActivity,DetailActivity } from '@pages/activity/index';
import { PhotoViewer } from '@ionic-native/photo-viewer';
import { File } from '@ionic-native/file';
import { FileTransfer, FileTransferObject } from '@ionic-native/file-transfer';
import { Utility } from '@providers/resources/utility';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { Geolocation } from '@ionic-native/geolocation';
import { TabsPage } from '@pages/dashboard';

@Component({
  selector: 'activity-me',
  templateUrl: 'page.html'
})
export class MyActivity {
  berita:any = '';
  loading : any;
  isLogin : any = 0;
  data = {
    activity:[],
    dateMulai:"",
    dateAkhir:"",
    dateJarak:"",
    location:{
      lat : 0,
      lng : 0,    
    }
  };
  state = {
    searching : true,
  };
  startDate:any = new Date;
  valDateJarak:any;
  today = this.helper.getToday();
  parameter : any = {
    id  : this.userApi.data.Employee_ID || 394,
    nik : this.userApi.data.NIK,
    date_start : this.today.awalYmd,
    date_end : this.today.akhirYmd,
    search : '',
    verification : {
      id : null,
      action : null,
      id_karyawan :this.userApi.data.Employee_ID,
      nama_karyawan : this.userApi.data.Nama_Karyawan,
    }
  }
  fileTransfer: FileTransferObject = this.transfer.create();
  @ViewChild('slidingItem') private itemSliding: ItemSliding;
  @ViewChild('contentSlide') private contentSliding: Item;
  @ViewChild('widgetSearch') private searchBar: Searchbar;

  constructor(
    private api           : ApiMyRadiant,
    public userApi        : User,
    public alertCtrl      : AlertController,
    public nav            : Nav,
    public utility        : Utility,
    public repositoryProvider : RepositoryMyRadiant,
    public helper         : HelperMyRadiant,
    public viewCtrl       : ViewController,
    private photoViewer   : PhotoViewer,
    private file          : File,
    private transfer      : FileTransfer,
    private geolocation       : Geolocation,
    private androidPermissions: AndroidPermissions,
    private events        : Events
  ) {
    this.valDateJarak = {
  		from:this.today.obj.awal,
  		to:this.today.obj.akhir
    };
    // this.getPosition();
    this.getListActivity();
  }

  ionViewWillEnter(){
    // this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.LOCATION).then(
    //   result => this.getPosition(),
    //   err => this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.LOCATION)
    // );
  }
  getListActivity(){
    this.loading = this.helper.showLoading('Loading Data..');
    let me = this;
    this.repositoryProvider.getListActivity(this.parameter).subscribe((resp:any) => {
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
      if(resp.success){
        me.data.activity = resp.data;
      }
    },(err) => {
      this.helper.presentToast('Error');
      try {
        this.loading.dismiss();
      } catch (error) {
        
      }
    }); 
  }
  openCalendar() {
    let me = this;
    this.helper.valDateJarak = this.valDateJarak;
    this.helper.openCalendar((data,role) => {

      if (role=="done") {
        let date = data;
        let from: CalendarResult = date.from;
        let to: CalendarResult = date.to;	
          this.startDate = from.dateObj;
          this.parameter.date_start = from.string;
          this.parameter.date_end = to.string;
          this.data.dateJarak = this.helper.dateToString(from.dateObj) + ' s/d ' + this.helper.dateToString(to.dateObj);
          me.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          }
          this.valDateJarak = {
            from : from.dateObj,
            to:to.dateObj
          };
          me.getListActivity();
          
      }
    })  
  }
  
  showSearch(){
    this.state.searching = false; 
    this.searchBar._fireFocus();
    
    setTimeout(() => {
      this.searchBar.setFocus();
      this.searchBar._animated;
      console.log(this.state.searching);
    }, 500);
  }
  cancelSearch(){
    this.state.searching = true; 
    this.searchBar._fireBlur();
    setTimeout(() => {
      this.searchBar.inputBlurred();
    }, 500);
  }

  previewAttachment(file){
    this.photoViewer.show(this.api.url+file);
  }
  downloadAttachment(file,name_real) {
    const url = this.api.url+file;
    this.loading = this.helper.showLoading("Downloading...");
    let direktori = this.utility.getDirMyRadiant();
    this.fileTransfer.download(url, direktori + name_real).then((entry) => {
      try {
        this.loading.dismiss();
        this.helper.presentSwal('Success','Download Complete. Your file has saved in '+entry.toURL());
      } catch (error) {}
    }, (error) => {
      // handle error
      console.log(error);
      try {
        this.loading.dismiss();
        
        this.helper.presentSwal('Failed','Error Download File. Check your connection and try again.','error');
      } catch (error) {}
    });
  }

  addActivity(){
    let me = this;
    // this.getPosition(() => {
    me.nav.push(AddActivity);
    // })
  }
  backMyRadiant(evt){
    this.nav.setRoot(TabsPage,{tabIndex:1});
    this.events.publish('modul:myradiant');
  }
  detailActivity(data){
    this.nav.push(DetailActivity,{data:data}); 
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/activity/myactivity/page.ts